import axios from "axios";
import enviromment from '../environment';
import { tokenInterceptor, responseSuccessInterceptor, responseErrorInterceptor } from './Interceptors';

const BaseApi = axios.create({
  baseURL: enviromment.api
});

BaseApi.interceptors.request.use(tokenInterceptor);
BaseApi.interceptors.response.use(responseSuccessInterceptor, responseErrorInterceptor);

export default BaseApi;